/* eslint-disable sort-keys */
export const container = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
    padding: '10px 0',
}
export const header = {
    '&&&': {
        color: '$embedHeadingHighlighted',
        textAlign: 'center',
        marginBottom: '10px',
        fontSize: '24px',
    },
}

export const description = {margin: 0}

export const uploadSection = {}

export const sectionTitle = {
    margin: '0 0 10px 0',
    fontWeight: 'bold',
}

export const addFilesButton = {
    'alignItems': 'center',
    'border': 'none',
    'borderRadius': '10px',
    'backgroundColor': '$questionnaireAttachmentItemBackground',
    'display': 'flex',
    'fontWeight': 500,
    'padding': '10px',
    'gap': '10px',
    'width': '100%',
    '&:hover': {backgroundColor: '$questionnaireAttachmentItemBackgroundHover'},
    '> div': {
        lineHeight: 0,
        svg: {
            width: '20px',
            height: '20px',
            color: '$icon',
        },
    },
}

export const buttonFooter = {
    display: 'flex',
    justifyContent: 'flex-end' as const,
    width: '100%',
    button: {padding: '$button'},
}

// file
export const fileList = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px',
    marginBottom: '10px',
}

export const fileItem = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    padding: '5px',
    borderRadius: '10px',
    backgroundColor: '$questionnaireAttachmentItemBackground',
    variants: {
        valid: {true: {border: '1px solid $questionnaireAttachmentValid'}},
        invalid: {true: {border: '1px solid $questionnaireAttachmentInvalid'}},
    },
}

export const fileInfo = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
}

export const fileInfoProgress = {marginTop: '5px'}

export const topFileInfo = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
}

export const fileProgress = {
    color: '$smallText',
    fontSize: '14px',
    whiteSpace: 'nowrap',

}

export const fileName = {
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}

export const fileSize = {
    color: '$smallText',
    fontSize: '14px',
}

export const fileThumbnailContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px',
    borderRadius: '10px',
    overflow: 'hidden',
    flexShrink: 0,
}

export const fileThumbnailImage = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
}

export const fileThumbnailIcon = {
    color: '$questionnaireFileIcon',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25px',
    height: '25px',
}

export const fileActions = {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
}

export const uploadedIcon = {
    margin: '5px',
    width: '20px',
    height: '20px',
    color: '$questionnaireAttachmentValid',
}

export const fileErrorMessage = {
    color: '$questionnaireAttachmentInvalid',
    fontSize: '14px',
}
